export const environment = {
  production: true,
  apiUrl:"https://backoffice.int.wrap.vwfs.io/",
  gaTrackingCode: "G-XZLZD16PBQ",
  captchaKey: "6Le0ON4aAAAAAOJpk9rYWEoWf0O82QB7rOM1aGry"
};
